import React, { useState, useEffect } from 'react';
import { collection, doc, getDoc } from 'firebase/firestore';
import { db } from './firebase';
import './AdventCalendar.css';

const AdventCalendar = () => {
  const [openedDoors, setOpenedDoors] = useState(new Set());
  const [contents, setContents] = useState({});
  const [loading, setLoading] = useState(false);
  const [selectedDay, setSelectedDay] = useState(null);
  const [calendarStarted, setCalendarStarted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  // Check if the calendar has started (June 5, 2026)
  useEffect(() => {
    const today = new Date();
    const startDate = new Date(2026, 5, 5); // June 5, 2026 (month is 0-indexed)
    setCalendarStarted(today >= startDate);

    if (today < startDate) {
      const daysUntil = Math.ceil((startDate - today) / (1000 * 60 * 60 * 24));
      setErrorMessage(`Calendar starts on June 5, 2026. ${daysUntil} days to go!`);
    }
  }, []);

  // Check if a door can be opened
  const canOpenDoor = (dayNumber) => {
    if (!calendarStarted) return false;

    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const doorDate = new Date(2026, 5, 4+dayNumber); // June dayNumber, 2026
    doorDate.setHours(0, 0, 0, 0);

    return today >= doorDate;
  };

  // Fetch content from Firestore
  const openDoor = async (dayNumber) => {
    if (!canOpenDoor(dayNumber)) {
      setErrorMessage(`This day is not available yet!`);
      return;
    }

    if (contents[dayNumber]) {
      setSelectedDay(dayNumber);
      return;
    }

    setLoading(true);
    setErrorMessage('');

    try {
      const docRef = doc(db, 'days', dayNumber.toString());
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        const data = docSnap.data();
        setContents(prev => ({
          ...prev,
          [dayNumber]: data.text || 'No content available'
        }));
        setOpenedDoors(prev => new Set([...prev, dayNumber]));
        setSelectedDay(dayNumber);
      } else {
        setErrorMessage(`No content found for day ${dayNumber}`);
      }
    } catch (error) {
      console.error('Error fetching content:', error);
      setErrorMessage(`Error loading content: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const closeDoor = () => {
    setSelectedDay(null);
  };

  return (
    <div className="advent-calendar">
      <h1>🎄 Summer Advent Calendar 🎄</h1>
      {errorMessage && <p className="error-message">{errorMessage}</p>}

      <div className="doors-grid">
        {Array.from({ length: 24 }, (_, i) => i + 1).map(dayNumber => (
          <button
            key={dayNumber}
            className={`door ${openedDoors.has(dayNumber) ? 'opened' : ''} ${
              !canOpenDoor(dayNumber) ? 'locked' : ''
            }`}
            onClick={() => openDoor(dayNumber)}
            disabled={!canOpenDoor(dayNumber)}
            title={
              !canOpenDoor(dayNumber)
                ? 'Not available yet'
                : 'Click to open'
            }
          >
            <span className="door-number">{dayNumber}</span>
            {openedDoors.has(dayNumber) && <span className="opened-badge">✓</span>}
          </button>
        ))}
      </div>

      {selectedDay !== null && (
        <div className="modal-overlay" onClick={closeDoor}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h2>June {selectedDay}, 2026</h2>
              <button className="close-btn" onClick={closeDoor}>✕</button>
            </div>
            <div className="modal-content">
              {loading ? (
                <p>Loading...</p>
              ) : (
                <p>{contents[selectedDay] || 'Loading...'}</p>
              )}
            </div>
            <button className="close-modal-btn" onClick={closeDoor}>Close</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdventCalendar;


